/*
 * @Author: JamesWong
 * @Description: 授权店铺繁体包
 * @Date: 2018-11-29 17:15:51
 * @Last Modified by: chutao.fang
 * @Last Modified time: 2020-07-30 10:02:21
 */
export default {
  authorizedChannel: '已授權店鋪',
  deletedStore: '刪除店鋪',
  hint: '提示',
  deletedStoreTips: '刪除後該店鋪將不能使用POS登陸,確定刪除該店鋪嗎?',
  cancel: '取消',
  confirmDelete: '確定刪除',
  addChannel: '新增店鋪',
  addAuthorizedChannel: '新增授權店鋪',
  order: '序號',
  storeNumber: '店鋪編號',
  storeAbbreviation: '店鋪簡稱',
  storeFullname: '店鋪全稱',
  confirm: '確定',
  searchAuthorizedChannel: '搜索已授權店鋪',
  searchChannel: '搜索未授權店鋪',
  authorizedChannelDeleted: '授權店鋪刪除成功！',
  authorizedChannelAdded: '授權店鋪新增成功！',
  '渠道配置中心': '渠道配置中心',
  '下载模版': '下載模版',
  '导入': '導入',
  '导入教程': '導入教程',
  '支持通过本地excel表快速导入渠道,点击': '支持通過本地excel表快速導入渠道,點擊',
  '下载模板': '下載模板',
  '模板第二行开始填写需导入的渠道编号，依次往下录入': '模板第二行開始填寫需導入的渠道編號，依次往下錄入',
  '选择全部': '選擇全部',
  '取消': '取消',
  '确定': '確定',
  '提示': '提示',
  '行导入成功，以下': '行導入成功，以下',
  '行数据导入失败': '行數據導入失敗',
  '渠道编号': '渠道編號',
  '知道了': '知道了'
}


// WEBPACK FOOTER //
// ./src/i18n/zh-hant/channel.js